export default {
  MAX_ATTACHMENT_SIZE: 5000000,
  s3: {
    REGION: "us-east-1",
    BUCKET: "ftc-app-orguploads"
  },
  apiGateway: {
    REGION: "us-east-1",
    URL: "https://a3x14jte3f.execute-api.us-east-1.amazonaws.com/prod"
  },
  cognito: {
    REGION: "us-east-1",
    USER_POOL_ID: "us-east-1_Zk6xsqyna",
    APP_CLIENT_ID: "5m4ggar4u9l69q7512s089pa80",
    IDENTITY_POOL_ID: "us-east-1:08bec4e9-9f67-42b7-9dfd-9ce66f515adc"
  }
};
/*
    USER_POOL_ID: "us-east-1_PuVIEZVs1",
    APP_CLIENT_ID: "4eq2fks7aojhk71io7qjpt4osr",
    IDENTITY_POOL_ID: "us-east-1:50c591ea-a6a3-4ebf-b071-cdec55e7733b"
*/


// WEBPACK FOOTER //
// ./src/config.js